<div class="vertical-content">
    <ng-content></ng-content>
</div>

